import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './PrivacyPolicy.module.scss';
import cn from 'classnames';
const PrivacyPolicy = ({ text, textEnd, className, target = '_self' }) => {
    return (_jsx("div", Object.assign({ className: cn(styles.element, className) }, { children: _jsxs("div", { children: [_jsx("span", { children: text }), ' ', _jsx("a", Object.assign({ href: "https://website.beta.equine.gg/terms-of-service/", target: target }, { children: textEnd }))] }) })));
};
export default PrivacyPolicy;
